import { bodyBgPosition } from './BodyBgStore.js';

export const updateBodyBgPosition = (value) => bodyBgPosition.update(oldValue => value);
